const initialState = {
  brands: [],
  brand: null,
  brandFeedback: null,
  lastCreatedBrand: null,
  selectedBrand: null,
  searchParams: null,
  totalPages: 1,
  totalCount: 0,
  size: 12,

  fetchingBrands: false,
  errorFetchingBrands: null,
  fetchingBrand: false,
  errorFetchingBrand: null,
  fetchingBrandFeedback: false,
  errorFetchingBrandFeedback: null,
  creatingBrand: false,
  errorCreatingBrand: null,
  isListView: false,

  deactivatedBrand: null,
  errorDeactivatingBrand: null,
  deactivatingBrand: false,
  errorUpdatingBrand: null,
  updatingBrand: false,
  apiKeyToBrandsMap: {},
  fetchingApiKeyBrandNumbers: false,
  errorFetchingApiKeyBrandNumbers: null,
  errorUpdatingAndRevettingBrand: null,
  updatingAndRevettingBrand: false,
};

export default initialState;
